import {
    action,
    observable,
} from 'mobx';
import {
    RequestStatus,
} from 'mobx-store';
import {
    CardsDeliveryStoreInterface,
    CardsDeliveryRequestsListResponse,
} from '../storeInterfaces/cardsDeliveryStoreInterface';
import {
    CardsDeliveryRequestDTO,
} from '../../screens/cardsDeliveryRequestsScreen/DTOs/cardsDeliveryRequestDTO';
import {
    cardsDelivery, cardsDeliveryExport,
    cardsDeliveryRequestsList,
    pickupBranchesListUrl,
} from '../../axios/requests';
import Connections from '../../connections';
import moment from "moment/moment";
import * as FileSaver from "file-saver";

export class CardsDeliveryStore implements CardsDeliveryStoreInterface {
    @observable cardsDeliveryRequestsList: CardsDeliveryRequestDTO[] = [];

    @observable getCardsDeliveryReqListRequestStatus: RequestStatus = RequestStatus.IDLE;

    @observable requestsCount = 0;

    @observable pickupBranchesList = [];

    @action
    public async getCardsDeliveryRequestsList(pageNumber: number, pageSize: number, params: any): Promise<void> {

        try {
            this.getCardsDeliveryReqListRequestStatus = RequestStatus.LOADING;

            const response = await Connections.wadiDeglaAxios.httpGet(cardsDeliveryRequestsList(
                pageNumber, pageSize, params.status, params.paid, params.q, params.from, params.to, params.branch, params.payment, params.paymentStatuses, params.requestType
            ));
            const {
                requests,
                requestsCount,
            } = response.data;
            this.requestsCount=requestsCount
            this.cardsDeliveryRequestsList = this.mapCDRequestsListResponse(requests);
            this.getCardsDeliveryReqListRequestStatus = RequestStatus.SUCCESS;
        } catch (error) {
            this.getCardsDeliveryReqListRequestStatus = RequestStatus.FAILED;
            console.error(error);
            throw await Promise.reject(error);
        }
    }

    @action
    public async updateCardStatus(requestId: number, status: number): Promise<void> {

        try {
            this.getCardsDeliveryReqListRequestStatus = RequestStatus.LOADING;
            await Connections.wadiDeglaAxios.httpPut(cardsDelivery, {status, cardId: requestId});
            this.getCardsDeliveryReqListRequestStatus = RequestStatus.SUCCESS;

        } catch (error) {
            this.getCardsDeliveryReqListRequestStatus = RequestStatus.FAILED;
            console.error(error);
            throw await Promise.reject(error);
        }

    }

    @action
    public async exportCardDelivery(params: any): Promise<void> {

        try {
            this.getCardsDeliveryReqListRequestStatus = RequestStatus.LOADING;
            const res = await Connections.wadiDeglaAxios.httpGet(cardsDeliveryExport(
                params.status, params.paid, params.q, params.from, params.to, params.branch, params.payment, params.paymentStatuses, params.requestType
            ), {responseType: 'blob'});
            this.getCardsDeliveryReqListRequestStatus = RequestStatus.SUCCESS;
            await FileSaver.saveAs(res, 'Transactions');
         } catch (error) {
            this.getCardsDeliveryReqListRequestStatus = RequestStatus.FAILED;
            console.error(error);
            // throw await Promise.reject(error);
        }

    }

    @action
    private mapCDRequestsListResponse(responseData: CardsDeliveryRequestsListResponse[]): CardsDeliveryRequestDTO[] {
        return responseData.map((res) => ({
            requestType: res.request_type,
            address: res.address,
            addressType: res.address_type,
            coordinateLat: res.latitude,
            coordinateLong: res.longitude,
            addressNotes: res.address_notes,
            cost: res.cost,
            membershipId: res.membership_id,
            paymentMethod: res.payment_method,
            phone: res.phone,
            userFirstName: res.userFirstName,
            status: res.status,
            day: res.delivery_day,
            timeRange: res.delivery_time_range ? moment(res.delivery_time_range).format('HH:mm') : '',
            requestId: res.requestId,
            sapTransactionId: res.sap_transaction_id,
            transactionId: res.transaction_id,
            pickupBranch: res.pickup_branch,
            main: !!res.main,
        } as CardsDeliveryRequestDTO));
    }

    @action
    public async getBranchesOptions() {
        try {
            let validBranchNames:string[] = [
                "Maadi", "Nakhil", "Heliopolis", "October 1", "October 2", "Muharram Bek - Alex", "Lotus",
                "Damietta", "Assiut", "Minya", "Maadi Waterfront", "Kenya", "Miami Waterfront", "Tanta",
            ];
             // @ts-ignore
            this.pickupBranchesList =  validBranchNames;
         } catch (error) {
            console.error(error);
        }
    }
}
